<template>
  <label
    :id
    class="relative"
    :class="$props.class"
    :data-test-id="dataTestId || 'base-radio'"
    @pointerdown="$emit('pointerdown')"
  >
    <input
      v-model="model"
      class="peer sr-only op-0"
      type="radio"
      v-bind="{ ...props, ...$attrs }"
      @change="$emit('change', ($event.target as HTMLInputElement)?.value)"
    >
    <slot />
  </label>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  value?: string | number
  name?: string
  id?: string
  class?: CSSClass
  dataTestId?: string
}>()

defineEmits<{
  change: [value: string]
  pointerdown: []
}>()

const model = defineModel<string | number>()
</script>
